import { render, staticRenderFns } from "./FormTipoFaixa.vue?vue&type=template&id=a6b3ce18"
import script from "./FormTipoFaixa.vue?vue&type=script&lang=js"
export * from "./FormTipoFaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports